var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react componetns
import moment from 'moment/moment';
// - Import action types
import { ImageGalleryActionType } from 'constants/imageGalleryActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
import { provider } from 'src/socialEngine';
/**
 * Get service providers
 */
var imageGalleryService = provider.get(SocialProviderTypes.ImageGalleryService);
/* _____________ UI Actions _____________ */
/**
 * Download images for image gallery
 */
export var dbGetImageGallery = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            return imageGalleryService.getImageGallery(uid)
                .then(function (images) {
                dispatch(addImageList(images));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/* _____________ CRUD Database_____________ */
/**
 * Save image URL in the server
 */
export var dbSaveImage = function (imageURL, imageFullPath) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var image = {
            creationDate: moment().unix(),
            deleteDate: '',
            imageArr: [imageURL],
            URL: imageURL,
            fullPath: imageFullPath,
            ownerUserId: uid,
            lastEditDate: 0,
            deleted: false
        };
        return imageGalleryService.saveImage(uid, image)
            .then(function (imageKey) {
            dispatch(addImage(__assign({}, image, { id: imageKey })));
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
export var dbSaveImages = function (imageURL, imageFullPath, imageArr) {
    return function (dispatch, getState) {
        var urlArray = [];
        imageArr.forEach(function (file) {
            urlArray.push(file.fileURL);
        });
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (urlArray.length === imageArr.length) {
            var image_1 = {
                creationDate: moment().unix(),
                deleteDate: '',
                imageArr: urlArray,
                URL: urlArray[0],
                fullPath: imageFullPath,
                ownerUserId: uid,
                lastEditDate: 0,
                deleted: false
            };
            return imageGalleryService.saveImage(uid, image_1)
                .then(function (imageKey) {
                dispatch(addImage(__assign({}, image_1, { id: imageKey })));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 * Delete an image from database
 * @param  {string} id of image
 */
export var dbDeleteImage = function (id) {
    return function (dispatch, getState) {
        // Get current user id
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        return imageGalleryService.deleteImage(uid, id)
            .then(function () {
            dispatch(deleteImage(id));
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
/**
 * Upload image on the server
 */
export var dbUploadImage = function (image, imageName) {
    return function (dispatch, getState) {
        console.log('prior', image);
        return imageGalleryService
            .uploadImage(image, imageName, function (percentage) {
            dispatch(globalActions.progressChange(percentage, true));
        })
            .then(function (result) {
            dispatch(globalActions.progressChange(100, false));
            console.log('fileres', result);
            dispatch(dbSaveImage(result.fileURL, result.fileFullPath));
            dispatch(globalActions.hideTopLoading());
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.code));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/**
 * Upload multiple images on the server2
 */
export var dbUploadImages = function (imageArr) {
    console.log('made it');
    return function (dispatch, getState) {
        console.log('prior');
        return imageGalleryService
            .uploadImages(imageArr, function (percentage) {
            dispatch(globalActions.progressChange(percentage, true));
        })
            .then(function (result) {
            if (result.length === imageArr.length) {
                dispatch(globalActions.progressChange(100, false));
                console.log('fileres', result);
                console.log('path', result[0].fileFullPath);
                console.log('URL', result[0].fileURL);
                dispatch(dbSaveImages(result[0].fileURL, result[0].fileFullPath, result));
                dispatch(globalActions.hideTopLoading());
            }
            else {
                console.log('somehow different');
                console.log(result);
                console.log(imageArr);
            }
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.code));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/**
 * Download image from server
 * @param {string} fileName
 */
export var dbDownloadImage = function (fileName) {
    return function (dispatch, getState) {
        if (fileName === 'noImage') {
            return {};
        }
        if (getState().imageGallery.imageURLList[fileName] && fileName !== '') {
            return undefined;
        }
        if (getState().imageGallery.imageRequests.indexOf(fileName) > -1) {
            return undefined;
        }
        dispatch(sendImageRequest(fileName));
        return imageGalleryService.downloadImage(fileName)
            .then(function (url) {
            // Insert url into an <img> tag to 'download'
            if (!getState().imageGallery.imageURLList[fileName] || fileName === '') {
                dispatch(setImageURL(fileName, url));
            }
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
/* _____________ CRUD State _____________ */
/**
 * Add image list to image gallery
 * @param {Image[]} images is an array of images
 */
export var addImageList = function (images) {
    return { type: ImageGalleryActionType.ADD_IMAGE_LIST_GALLERY, payload: images };
};
/**
 * Add image to image gallery
 * @param {Image} image
 */
export var addImage = function (image) {
    return { type: ImageGalleryActionType.ADD_IMAGE_GALLERY, payload: image };
};
/**
 * Delete an image
 * @param  {string} id is an image identifier
 */
export var deleteImage = function (id) {
    return { type: ImageGalleryActionType.DELETE_IMAGE, payload: id };
};
/**
 * Delete an image
 */
export var setImageURL = function (name, url) {
    return {
        type: ImageGalleryActionType.SET_IMAGE_URL,
        payload: { name: name, url: url }
    };
};
/**
 * Clear all data in image gallery store
 */
export var clearAllData = function () {
    return {
        type: ImageGalleryActionType.CLEAT_ALL_DATA_IMAGE_GALLERY
    };
};
/**
 * Send image request
 */
export var sendImageRequest = function (name) {
    return {
        type: ImageGalleryActionType.SEND_IMAGE_REQUEST,
        payload: name
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/imageGalleryActions.ts
// module id = 399
// module chunks = 50